const article = {
    id: 'rejections',
    title: 'Rejections',
    summary: 'Review rejection notifications for one client or all clients, and rerun the ones currently on screen.',
    publishedAt: '2026-09-14',
    tags: ['rejections', 'sidebar'],
    sections: [
        {
            type: 'paragraph',
            text: 'Rejections lists rejection notifications in one place. You can limit the list to a client and rerun every visible item that has a rerun action.',
        },
        { type: 'heading', text: 'When to use' },
        {
            type: 'paragraph',
            text: 'Use it when rejected work needs another pass and you do not want to open each notification separately.',
        },
        { type: 'heading', text: 'How to use' },
        {
            type: 'steps',
            items: [
                'Open Rejections in the sidebar.',
                'Use Filter by client, or leave it on All.',
                'Check the shown count against the total.',
                'Rerun the visible items. Failures are reported; successful ones are submitted together.',
            ],
        },
        {
            type: 'note',
            text: 'Rerun only acts on rows that are visible after the client filter.',
        },
    ],
};

export default article;
